var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  environment: process.env.NEXT_PUBLIC_DEPLOY_TARGET || 'development',
  dsn:
    SENTRY_DSN ||
    'https://9bd0f919f80b45128af4f2811bf7cd8d@o144472.ingest.sentry.io/6268731',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.05, //0.05 => 5%. The value should be between 0 to 1. Set 0 to completely disable.
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  //enabled: process.env.NEXT_PUBLIC_DEPLOY_TARGET !== 'development'
  enabled: true
});
